<script setup lang="ts">
import router from "@/router";
import { ref, computed } from 'vue'
import { useRoute } from "vue-router";

const menus = ref([
    {
        label: "试卷库",
        name: "Paper",
    },
    {
        label: "试题库",
        name: "Question",
    },
    {
        label: "考试记录",
        name: "PaperLog",
    },{
        label: "试题分类",
        name: "QuestionCategory",
    }
])
const route = useRoute()
const activeIndex = computed(() => {
    return route.name
})
const handleSelect = (index: string) => {
    router.push({name: index})
}
</script>

<template>
    <div class="h-screen p-5 flex flex-col">
        <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
        >
            <el-menu-item v-for="(item) in menus" :key="item.name" :index="item.name as string">{{item.label}}</el-menu-item>
        </el-menu>
        <main class="main-wrap flex-1 h-full bg-page">
            <el-scrollbar>
                <div class="p-4">
                    <router-view v-slot="{ Component, route }">
                        <component :is="Component" :key="route.fullPath" />
                    </router-view>
                </div>
            </el-scrollbar>
        </main>
    </div>
</template>

<style scoped lang="scss">

</style>
